var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilesGiftcards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36596",
    "data-name": "Group 36596",
    transform: "translate(-276 -631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28575",
    "data-name": "Group 28575",
    transform: "translate(-1646 -2483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28657",
    "data-name": "Group 28657",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37445",
    "data-name": "Path 37445",
    d: "M628.079,472.079a28,28,0,1,0,28,28A28,28,0,0,0,628.079,472.079Z",
    transform: "translate(1324.921 2641.921)",
    fill: "#fc3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36595",
    "data-name": "Group 36595",
    transform: "translate(289 644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39854",
    "data-name": "Path 39854",
    d: "M25.667,8H4.333A1.333,1.333,0,0,0,3,9.333V12a1.333,1.333,0,0,0,1.333,1.333H25.667A1.333,1.333,0,0,0,27,12V9.333A1.333,1.333,0,0,0,25.667,8Z",
    transform: "translate(0 1.667)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39855",
    "data-name": "Path 39855",
    d: "M12,8V25.333",
    transform: "translate(3 1.667)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39856",
    "data-name": "Path 39856",
    d: "M23.667,12v9.333A2.667,2.667,0,0,1,21,24H7.667A2.667,2.667,0,0,1,5,21.333V12",
    transform: "translate(0.667 3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39857",
    "data-name": "Path 39857",
    d: "M8.333,9.667A3.333,3.333,0,0,1,8.333,3a4.8,4.8,0,0,1,3.617,1.792,11.3,11.3,0,0,1,2.383,4.875,11.308,11.308,0,0,1,2.383-4.875A4.8,4.8,0,0,1,20.333,3a3.333,3.333,0,1,1,0,6.667",
    transform: "translate(0.667 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilesGiftcards);
export default __webpack_public_path__ + "static/media/miles-giftcards.cf5bc6815525f59732befffa6d8dfbfa.svg";
export { ForwardRef as ReactComponent };